import { Component, Host, h, Element } from '@stencil/core';

export interface AhaCardGroup extends HTMLAhaCardGroupElement {}

/**
 * Starter component
 * @slot default - Contents of the default slot.
 */
@Component({
  tag: 'aha-card-group',
  styleUrl: 'aha-card-group.css',
  shadow: true,
})
export class AhaCardGroup {
  @Element() host!: HTMLAhaCardGroupElement;
  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
